<template>
  <div class="hris-page">
    <div class="hris-page-inner">
    <div class="hris-page-header">
      <span class="hris-page-eyebrow">Leaves</span>
      <h1 class="hris-page-title">My Leave Credits</h1>
      <p class="hris-page-subtitle">Review your accrued and remaining leave balances.</p>
    </div>

    <template v-if="is_pto_enabled">
      <div class="hris-grid" style="margin-bottom: 20px;">
        <div class="hris-stat-card">
          <p class="hris-stat-label">Remaining Credits</p>
          <p class="hris-stat-value">{{ remaining }}</p>
        </div>
        <div class="hris-stat-card">
          <p class="hris-stat-label">Total Earned</p>
          <p class="hris-stat-value">{{ earned }}</p>
        </div>
        <div class="hris-stat-card">
          <p class="hris-stat-label">Total Availed</p>
          <p class="hris-stat-value">{{ availed }}</p>
        </div>
      </div>
    </template>
    <template v-else-if="is_pto_enabled === false">
      <div class="hris-grid" style="margin-bottom: 20px;">
        <div class="hris-stat-card">
          <p class="hris-stat-label">Max VL Credits</p>
          <p class="hris-stat-value">{{ max_vl }}</p>
        </div>
        <div class="hris-stat-card">
          <p class="hris-stat-label">Max SL Credits</p>
          <p class="hris-stat-value">{{ max_sl }}</p>
        </div>
        <div class="hris-stat-card">
          <p class="hris-stat-label">Total Earned VL</p>
          <p class="hris-stat-value">{{ vl_earned }}</p>
        </div>
        <div class="hris-stat-card">
          <p class="hris-stat-label">Total Earned SL</p>
          <p class="hris-stat-value">{{ sl_earned }}</p>
        </div>
        <div class="hris-stat-card">
          <p class="hris-stat-label">Availed Vacation Leave</p>
          <p class="hris-stat-value">{{ vl_availed }}</p>
        </div>
        <div class="hris-stat-card">
          <p class="hris-stat-label">Availed Sick Leave</p>
          <p class="hris-stat-value">{{ sl_availed }}</p>
        </div>
        <div class="hris-stat-card">
          <p class="hris-stat-label">Remaining VL Credits</p>
          <p class="hris-stat-value">{{ vl_remaining }}</p>
        </div>
        <div class="hris-stat-card">
          <p class="hris-stat-label">Remaining SL Credits</p>
          <p class="hris-stat-value">{{ sl_remaining }}</p>
        </div>
      </div>
    </template>

    <div class="hris-grid" style="margin-bottom: 20px;" v-if="is_pto_enabled !== null">
      <div class="hris-stat-card">
        <p class="hris-stat-label">Availed Maternity Leave</p>
        <p class="hris-stat-value">
          <q-icon :name="ml_availment" :color="ml_avail_color" size="1.5em" />
        </p>
      </div>
      <div class="hris-stat-card">
        <p class="hris-stat-label">Availed Paternity Leave</p>
        <p class="hris-stat-value">
          <q-icon :name="pl_availment" :color="pl_avail_color" size="1.5em" />
        </p>
      </div>
      <div class="hris-stat-card">
        <p class="hris-stat-label">Availed Magna Carta Leave</p>
        <p class="hris-stat-value">
          <q-icon :name="mc_availment" :color="mc_avail_color" size="1.5em" />
        </p>
      </div>
      <div class="hris-stat-card">
        <p class="hris-stat-label">Availed Solo Parent Leave</p>
        <p class="hris-stat-value">
          <q-icon :name="sp_availment" :color="sp_avail_color" size="1.5em" />
        </p>
      </div>
    </div>

    <div class="hris-panel" v-if="is_pto_enabled !== null">
      <div class="hris-form-section-title">Leave Spread (Monthly Accruals)</div>
      <q-table flat class="center-cell" :data="leaveSpreadData" :columns="leaveSpreadColumns" row-key="name" hide-bottom separator="cell">
        <q-tr slot="body" slot-scope="props" :props="props">
          <q-td key="year" :props="props">{{ props.row.year }}</q-td>
          <q-td v-for="(earned,index) in props.row.earned" :key="index">
            <template v-if="is_pto_enabled">
              {{ (parseFloat(earned.vl || 0) + parseFloat(earned.sl || 0)).toFixed(2) }}
            </template>
            <template v-else>
              {{ earned.vl }} / {{ earned.sl }}
            </template>
          </q-td>
          <q-td key="total" :props="props">{{ props.row.total }}</q-td>
        </q-tr>
        <template v-slot:no-data>
          <div class="hris-empty full-width">No leave spread data available</div>
        </template>
      </q-table>
    </div>

    <q-dialog v-model="loadingModel" persistent>
      <div class="hris-loading" style="background: transparent; min-width: 200px;">
        <q-spinner color="green" size="3em" />
        <div>Fetching Records</div>
      </div>
    </q-dialog>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { date } from 'quasar';
import { mapGetters } from 'vuex';
let today = Date.now();
let dateToday = date.formatDate(today, 'MM-DD-YYYY-hhmmA');
export default {
  name: 'MyLeaveCredits',
  data() {
    return {
      dateToday,
      loadingModel: false,
      max_vl: null,
      max_sl: null,
      vl_earned: null,
      sl_earned: null,
      vl_availed: null,
      sl_availed: null,
      vl_remaining: null,
      sl_remaining: null,
      earned: null,
      availed: null,
      remaining: null,
      ml_availed: null,
      ml_availment: 'fa fa-times',
      ml_avail_color: 'red-10',
      pl_availed: null,
      pl_availment: 'fa fa-times',
      pl_avail_color: 'red-10',
      mc_availed: null,
      mc_availment: 'fa fa-times',
      mc_avail_color: 'red-10',
      sp_availed: null,
      sp_availment: 'fa fa-times',
      sp_avail_color: 'red-10',
      leaveSpreadData: [],
      leaveSpreadColumns: [{
          name: 'year',
          field: 'year',
          label: 'Year',
          align: 'center',
          style: 'font-weight: bold; width: 100px',
          classes: 'bg-grey-2',
          headerClasses: 'bg-blue-8 text-white text-center',
          headerStyle: 'width: 100px'
        },
        {
          name: 'january',
          field: 'january',
          label: 'Jan',
          align: 'center',
          style: 'width: 80px',
          headerClasses: 'bg-blue-8 text-white',
          headerStyle: 'width: 80px'
        },
        {
          name: 'february',
          field: 'february',
          label: 'Feb',
          align: 'center',
          style: 'width: 80px',
          headerClasses: 'bg-blue-8 text-white',
          headerStyle: 'width: 80px'
        },
        {
          name: 'march',
          field: 'march',
          label: 'Mar',
          align: 'center',
          style: 'width: 80px',
          headerClasses: 'bg-blue-8 text-white',
          headerStyle: 'width: 80px'
        },
        {
          name: 'april',
          field: 'april',
          label: 'Apr',
          align: 'center',
          style: 'width: 80px',
          headerClasses: 'bg-blue-8 text-white',
          headerStyle: 'width: 80px'
        },
        {
          name: 'may',
          field: 'may',
          label: 'May',
          align: 'center',
          style: 'width: 80px',
          headerClasses: 'bg-blue-8 text-white',
          headerStyle: 'width: 80px'
        },
        {
          name: 'june',
          field: 'june',
          label: 'Jun',
          align: 'center',
          style: 'width: 80px',
          headerClasses: 'bg-blue-8 text-white',
          headerStyle: 'width: 80px'
        },
        {
          name: 'july',
          field: 'july',
          label: 'Jul',
          align: 'center',
          style: 'width: 80px',
          headerClasses: 'bg-blue-8 text-white',
          headerStyle: 'width: 80px'
        },
        {
          name: 'august',
          field: 'august',
          label: 'Aug',
          align: 'center',
          style: 'width: 80px',
          headerClasses: 'bg-blue-8 text-white',
          headerStyle: 'width: 80px'
        },
        {
          name: 'september',
          field: 'september',
          label: 'Sep',
          align: 'center',
          style: 'width: 80px',
          headerClasses: 'bg-blue-8 text-white',
          headerStyle: 'width: 80px'
        },
        {
          name: 'october',
          field: 'october',
          label: 'Oct',
          align: 'center',
          style: 'width: 80px',
          headerClasses: 'bg-blue-8 text-white',
          headerStyle: 'width: 80px'
        },
        {
          name: 'november',
          field: 'november',
          label: 'Nov',
          align: 'center',
          style: 'width: 80px',
          headerClasses: 'bg-blue-8 text-white',
          headerStyle: 'width: 80px'
        },
        {
          name: 'december',
          field: 'december',
          label: 'Dec',
          align: 'center',
          style: 'width: 80px',
          headerClasses: 'bg-blue-8 text-white',
          headerStyle: 'width: 80px'
        },
        {
          name: 'total',
          field: 'total',
          label: 'Total',
          align: 'center',
          style: 'width: 80px',
          headerClasses: 'bg-blue-8 text-white',
          headerStyle: 'width: 80px'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
        userData: 'auth/getUser'
    }),
    is_pto_enabled() {
      return this.userData?.features?.includes('pto') ?? false;
    }
  },
  methods: {
    loadCredits: function() {
      this.loadingModel = true;

      // Fetch actual leave credits
      axios.create({
          baseURL: this.apiUrl,
          headers: {
            'Authorization': `Bearer ${this.token}`
          }
        })
        .get('/leave/credits/retrieve', {
          params: {
            category: 'single',
            keyword: 'user'
          }
        })
        .then((res) => {
          let leaveCredits = res.data.data;
          this.max_vl = leaveCredits.max_vl;
          this.max_sl = leaveCredits.max_sl;
          this.vl_earned = leaveCredits.vl_earned;
          this.sl_earned = leaveCredits.sl_earned;
          this.vl_availed = leaveCredits.vl_availed;
          this.sl_availed = leaveCredits.sl_availed;
          this.vl_remaining = leaveCredits.vl_remaining;
          this.sl_remaining = leaveCredits.sl_remaining;
          this.earned = leaveCredits.earned;
          this.availed = leaveCredits.availed;
          this.remaining = leaveCredits.remaining;
          
          this.ml_availed = leaveCredits.ml_availed;
          this.pl_availed = leaveCredits.pl_availed;
          this.mc_availed = leaveCredits.mc_availed;
          this.sp_availed = leaveCredits.sp_availed;
          this.leaveSpreadData = leaveCredits.plotted;
          if (this.ml_availed > 0) {
            this.ml_availment = 'fa fa-check';
            this.ml_avail_color = 'green-10';
          }
          if (this.pl_availed > 0) {
            this.pl_availment = 'fa fa-check';
            this.pl_avail_color = 'green-10';
          }
          if (this.mc_availed > 0) {
            this.mc_availment = 'fa fa-check';
            this.mc_avail_color = 'green-10';
          }
          if (this.sp_availed > 6) {
            this.sp_availment = 'fa fa-check';
            this.sp_avail_color = 'green-10';
          }
        })
        .finally(() => {
          this.loadingModel = false;
        });
    }
  },
  mounted() {
  this.loadCredits();
  }
}
</script>
<style lang="css" scoped>
.center-cell td {
  text-align: center;
}

.hris-page >>> .q-table th {
  background: var(--hris-surface-muted, #f1f3f5) !important;
  color: var(--hris-text-secondary, #5c6370) !important;
}
</style>
